module.exports = __webpack_public_path__ + "static/welcome_sheet.1758c836.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/welcome_sheet.jpg
// module id = 585
// module chunks = 35783957827783